import React, { useState } from 'react';
import { TimePicker } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

const HourMinuteEditorForUhomeSinglePhase = ({value, pendingValue, onChange}) => {
    dayjs.extend(customParseFormat);
    let str = (value??0).toString(16).padStart(4,"0");
    str = parseInt(str.substr(0,2), 16).toString().padStart(2,"0").concat(":", parseInt(str.substr(-2,2), 16).toString().padStart(2,"0"));
    const ot = dayjs(str, "HH:mm");

    const onTimeChange = (time, timeString) => {
        const v = time.format("HHmm");
        const hours = parseInt(time.format("HH"));
        const minutes = parseInt(time.format("mm")); 
        const hexValue = (hours << 8) | minutes;
        onChange?.(hexValue);
    }

    if (pendingValue!=undefined&&pendingValue!=null) {
        return <TimePicker format={"HH:mm"} 
            value={ot}
            suffixIcon={ <EditOutlined />}
            allowClear={false}
            onChange={onTimeChange}
        />;
    }
    return <TimePicker format={"HH:mm"} 
        value={ot}
        allowClear={false}
        onChange={onTimeChange}
    />;
}

export default HourMinuteEditorForUhomeSinglePhase;